import React from 'react';
import { Link, NavLink, Switch, Route } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

import * as ROUTES from '../../constants/routes';

import About from './About';
import ContactUs from './ContactUs';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import CookiesUse from './CookiesUse';

const pages = [
  {
    route: ROUTES.ABOUT,
    title: 'info.about',
    component: About,
  },
  {
    route: ROUTES.CONTACT,
    title: 'info.contact',
    component: ContactUs,
  },
  {
    route: ROUTES.TOS,
    title: 'info.tos',
    component: TermsOfService,
  },
  {
    route: ROUTES.PP,
    title: 'info.privacy',
    component: PrivacyPolicy,
  },
  {
    route: ROUTES.CU,
    title: 'info.cookies',
    component: CookiesUse,
  },
];

export default function Info() {
  const { t } = useTranslation();

  return (
    <>
      <div className="nav-scroller bg-white shadow-sm mb-2">
        <div className="container">
          <nav className="nav nav-underline">
            {pages.map(page => (
              <NavLink
                key={page.route}
                className="nav-link"
                activeClassName="active"
                to={page.route}
              >
                {t(page.title)}
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <Switch>
        {pages.map(page => (
          <Route
            key={page.route}
            exact
            path={page.route}
            component={page.component}
          />
        ))}
      </Switch>
    </>
  );
}

export function PolicyText() {
  const { t } = useTranslation();

  return (
    <p className="text-center">
      <Trans
        i18nKey="auth.policyText.full"
        components={{
          tos: <Link to={ROUTES.TOS} />,
          privacy: <Link to={ROUTES.PP} />,
          cookies: <Link to={ROUTES.CU} />,
        }}
        values={{
          tos: t('info.tos'),
          privacy: t('info.privacy'),
          cookies: t('info.cookies'),
        }}
      />
    </p>
  );
}
